import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root',
})
export class ClientSettingsService {
  constructor(private oidcSecurityService: OidcSecurityService) {}

  public remove(key: string, local = true) {
    const { clientId } = this.oidcSecurityService.getConfiguration();
    const storage = local
      ? localStorage.getItem(clientId)
      : sessionStorage.getItem(clientId);
    const settings = storage == undefined ? {} : JSON.parse(storage);
    delete settings[key];

    if (local) localStorage.setItem(clientId, JSON.stringify(settings));
    if (!local) sessionStorage.setItem(clientId, JSON.stringify(settings));
  }

  public set(key: string, value: any, local = true) {
    const { clientId } = this.oidcSecurityService.getConfiguration();
    const storage = local
      ? localStorage.getItem(clientId)
      : sessionStorage.getItem(clientId);
    const settings = storage == undefined ? {} : JSON.parse(storage);
    settings[key] = value;

    if (local) localStorage.setItem(clientId, JSON.stringify(settings));
    if (!local) sessionStorage.setItem(clientId, JSON.stringify(settings));
  }

  public get(key: string, local = true) {
    const { clientId } = this.oidcSecurityService.getConfiguration();
    const settings = local
      ? JSON.parse(localStorage.getItem(clientId))
      : JSON.parse(sessionStorage.getItem(clientId));
    return settings == undefined ? '' : settings[key];
  }
}
